module.exports = __webpack_public_path__ + "static/media/hollow_bar_postlapAERO_hand.9a676b19.svg";